/* ============================================================
   ILS — Add-to-cart mini toast + flying thumbnail (TASK-1761)

   Part A (UNCHANGED from TASK-1757): monkey-patch CartDrawer /
           CartNotification renderContents so that a successful
           /cart/add.js no longer auto-opens the drawer /
           notification. Section morph still happens (counters,
           items, icon-bubble update), only the open() call is
           suppressed. Clicking the .ils-cart icon still opens
           the drawer via cart-drawer.js setHeaderCartIconAccessibility.

   Part B (TASK-1761): centered floating toast + decorative
           flying thumbnail.

   TASK-2071 — owner report: the flying product thumbnail sometimes
   played TWICE for a single add-to-cart click. Root cause: if a SECOND
   /cart/add request landed within the 8s "recent click" window (e.g. an
   automatic gift/bonus line item added right after the user's own add),
   it still matched the same lastClickedAddBtn and replayed the fly for
   it. Fix: the instant a fly (or its fallback) fires for a given click,
   that click is "consumed" — lastClickedAddBtn is cleared so a second
   /cart/add in the same window can never reuse it.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Localized labels ---------- */
  var LABELS = {
    ru: 'Добавлено',
    de: 'Hinzugefügt',
    en: 'Added to cart',
    lv: 'Pievienots',
    et: 'Lisatud',
    lt: 'Pridėta'
  };

  function pickLabel() {
    var raw = '';
    try { if (typeof window.ILS_LANG === 'string' && window.ILS_LANG) raw = window.ILS_LANG; } catch (e) {}
    if (!raw) {
      try {
        var bodyLang = document.body && document.body.getAttribute && document.body.getAttribute('data-ils-lang');
        if (bodyLang) raw = bodyLang;
      } catch (e) {}
    }
    if (!raw) {
      try { raw = (window.Shopify && Shopify.locale) || ''; } catch (e) {}
    }
    if (!raw) {
      raw = (document.documentElement && document.documentElement.lang) || '';
    }
    raw = String(raw || '').toLowerCase().slice(0, 2);
    return LABELS[raw] || LABELS.en;
  }

  /* ---------- Sequential chain: bump-done → toast ---------- */
  document.addEventListener('ils:add:bump-done', function () { showToastCenter(); });

  /* ---------- Part A: suppress auto-open after /cart/add.js ---------- */
  function patchCartElement(tag) {
    if (!window.customElements || typeof customElements.whenDefined !== 'function') return;
    customElements.whenDefined(tag).then(function () {
      var ctor = customElements.get(tag);
      if (!ctor || !ctor.prototype) return;
      var proto = ctor.prototype;
      if (proto.__ilsNoOpenPatched) return;
      proto.__ilsNoOpenPatched = true;

      proto.renderContents = function (parsedState) {
        try {
          if (parsedState && parsedState.key) this.cartItemKey = parsedState.key;
          if (parsedState && parsedState.id != null) this.productId = parsedState.id;

          var inner = this.querySelector('.drawer__inner');
          if (inner && inner.classList.contains('is-empty')) {
            inner.classList.remove('is-empty');
          }
          if (typeof this.getSectionsToRender === 'function') {
            this.getSectionsToRender().forEach(function (section) {
              var __sid = section.id || (section.selector || '');
              if (__sid === 'cart-icon-bubble' || (typeof __sid === 'string' && __sid.indexOf('cart-icon-bubble') !== -1)) {
                return;
              }
              var node = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
              if (!node) {
                if (section.id) node = document.getElementById(section.id);
                if (!node) return;
              }
              var html = parsedState && parsedState.sections && parsedState.sections[section.id];
              if (html == null) return;
              node.innerHTML = typeof this.getSectionInnerHTML === 'function'
                ? this.getSectionInnerHTML(html, section.selector)
                : html;
            }.bind(this));
          }

          var self = this;
          setTimeout(function () {
            var overlay = self.querySelector && self.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof self.close === 'function') {
              overlay.addEventListener('click', self.close.bind(self));
            }
          });
        } catch (e) {
          /* swallow — never block the add path */
        }
        // Intentionally NO this.open() — TASK-1757 disables auto-open.
      };
    });
  }

  patchCartElement('cart-drawer');
  patchCartElement('cart-notification');

  /* ---------- Part B: tracking the most-recent add click ---------- */
  var lastClickedAddBtn = null;
  var lastClickedAt = 0;
  var lastClickedRect = null;
  var currentToast = null;
  var currentToastTimers = { hold: null, remove: null };

  var ADD_BUTTON_SELECTOR = [
    '[data-upsell-add]',
    'product-form button[type="submit"]',
    'product-form button[name="add"]',
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] button[name="add"]',
    'button.product-form__submit'
  ].join(',');

  function rememberAddClick(e) {
    var btn = e.target && e.target.closest && e.target.closest(ADD_BUTTON_SELECTOR);
    if (!btn) return;
    lastClickedAddBtn = btn;
    lastClickedAt = Date.now();
    try {
      var rr = btn.getBoundingClientRect();
      lastClickedRect = (rr && (rr.width || rr.height))
        ? { left: rr.left, top: rr.top, width: rr.width, height: rr.height }
        : null;
    } catch (e2) { lastClickedRect = null; }
  }
  document.addEventListener('click', rememberAddClick, true);
  document.addEventListener('pointerdown', rememberAddClick, true);

  /* ---------- Centered toast ---------- */
  function removeToast(reason) {
    if (!currentToast) return;
    var t = currentToast;
    currentToast = null;
    if (currentToastTimers.hold) { clearTimeout(currentToastTimers.hold); currentToastTimers.hold = null; }
    if (currentToastTimers.remove) { clearTimeout(currentToastTimers.remove); currentToastTimers.remove = null; }
    t.classList.add('is-out');
    t.classList.remove('is-in');
    var delay = (reason === 'replace') ? 0 : 360;
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, delay);
  }

  function buildToast() {
    var el = document.createElement('div');
    el.className = 'ils-add-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<svg class="ils-add-toast__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
        '<path d="M3.5 8.5 L6.8 11.6 L12.8 5.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="ils-add-toast__text"></span>';
    return el;
  }

  function showToastCenter() {
    if (!document.body) return;

    if (currentToast) removeToast('replace');

    var label = pickLabel();
    var toast = buildToast();
    toast.querySelector('.ils-add-toast__text').textContent = label;
    document.body.appendChild(toast);
    currentToast = toast;

    requestAnimationFrame(function () {
      toast.classList.add('is-in');
    });

    currentToastTimers.hold = setTimeout(function () {
      if (currentToast !== toast) return;
      toast.classList.add('is-out');
      toast.classList.remove('is-in');
      currentToastTimers.remove = setTimeout(function () {
        if (currentToast === toast) currentToast = null;
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 360);
    }, 3000);
  }

  /* ---------- Fly thumbnail ---------- */
  function isCartDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList && drawer.classList.contains('active')) return true;
    return false;
  }

  function findProductImageForBtn(btn) {
    if (!btn) return null;
    var SELECTORS = [
      'product-info',
      '.product__info-wrapper',
      '.product',
      '.card-wrapper',
      '.card',
      'product-card',
      '.grid__item',
      'li.grid__item',
      '.card-information'
    ];
    for (var i = 0; i < SELECTORS.length; i++) {
      var container = btn.closest(SELECTORS[i]);
      if (!container) continue;
      var img = container.querySelector('img');
      if (img && (img.currentSrc || img.src)) return img.currentSrc || img.src;
    }
    var node = btn.parentElement;
    var hops = 0;
    while (node && node !== document.body && hops < 8) {
      var any = node.querySelector && node.querySelector('img');
      if (any && (any.currentSrc || any.src)) return any.currentSrc || any.src;
      node = node.parentElement;
      hops += 1;
    }
    return null;
  }

  function pulseCartIcon() {
    var iconWrap = document.querySelector('#cart-icon-bubble');
    if (!iconWrap) return;
    var prevTransform = iconWrap.style.transform;
    var prevTransition = iconWrap.style.transition;
    iconWrap.style.transition = 'transform 120ms ease-out';
    iconWrap.style.transform = 'scale(1.08)';
    setTimeout(function () {
      iconWrap.style.transform = prevTransform || '';
      setTimeout(function () {
        iconWrap.style.transition = prevTransition || '';
      }, 140);
    }, 120);
  }

  function dispatchFlyLanded() {
    try { document.dispatchEvent(new CustomEvent('ils:add:fly-landed')); } catch (e) {}
  }

  function flyToCart(btn) {
    var landedFired = false;
    function fireLanded() {
      if (landedFired) return;
      landedFired = true;
      dispatchFlyLanded();
    }

    if (!btn || !document.body) { fireLanded(); return; }
    if (isCartDrawerOpen()) { fireLanded(); return; }

    var cartIconWrap = document.querySelector('#cart-icon-bubble') || document.querySelector('.ils-cart');
    if (!cartIconWrap) { fireLanded(); return; }

    var btnRect = (lastClickedRect && btn === lastClickedAddBtn)
      ? lastClickedRect
      : btn.getBoundingClientRect();
    var iconRect = cartIconWrap.getBoundingClientRect();
    if (btnRect.width === 0 && btnRect.height === 0) { fireLanded(); return; }
    if (iconRect.width === 0 && iconRect.height === 0) { fireLanded(); return; }

    var startX = btnRect.left + btnRect.width / 2;
    var startY = btnRect.top + btnRect.height / 2;
    var endX = iconRect.left + iconRect.width / 2;
    var endY = iconRect.top + iconRect.height / 2;
    var dx = endX - startX;
    var dy = endY - startY;

    var imgSrc = findProductImageForBtn(btn);

    var fly = document.createElement('div');
    fly.className = 'ils-fly';
    if (imgSrc) {
      var img = document.createElement('img');
      img.className = 'ils-fly__img';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.src = imgSrc;
      fly.appendChild(img);
    } else {
      fly.classList.add('ils-fly--fallback');
      fly.innerHTML =
        '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
          '<path d="M3.5 8.5 L6.8 11.6 L12.8 5.2" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
    }
    fly.style.left = Math.round(startX) + 'px';
    fly.style.top = Math.round(startY) + 'px';
    document.body.appendChild(fly);

    var midDx = dx / 2;
    var arcLift = Math.min(120, Math.max(40, Math.abs(dx) * 0.3));
    var midDy = dy / 2 - arcLift;

    var supportsWAAPI = typeof fly.animate === 'function';
    var cleanup = function () {
      if (fly.parentNode) fly.parentNode.removeChild(fly);
      fireLanded();
    };

    if (supportsWAAPI) {
      var anim = fly.animate([
        { transform: 'translate(-50%, -50%) translate(0px, 0px) scale(1) rotate(0deg)',                       opacity: 1,    offset: 0 },
        { transform: 'translate(-50%, -50%) translate(' + midDx + 'px, ' + midDy + 'px) scale(0.75) rotate(140deg)', opacity: 0.95, offset: 0.55 },
        { transform: 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) scale(0.3) rotate(260deg)', opacity: 0,    offset: 1 }
      ], { duration: 800, easing: 'ease-in-out', fill: 'forwards' });
      anim.onfinish = cleanup;
      setTimeout(function () { if (fly.parentNode) cleanup(); }, 1100);
    } else {
      fly.style.transition = 'transform 800ms ease-in-out, opacity 800ms ease-in-out';
      fly.style.transform = 'translate(-50%, -50%) translate(0,0) scale(1)';
      requestAnimationFrame(function () {
        fly.style.transform = 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) scale(0.3)';
        fly.style.opacity = '0';
      });
      setTimeout(cleanup, 850);
    }
  }

  /* ---------- fetch interceptor: detect successful /cart/add.js ---------- */
  function isAddUrl(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && typeof input.url === 'string') url = input.url;
    else if (input && typeof input.toString === 'function') url = input.toString();
    if (!url) return false;
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var add = isAddUrl(input);
      var btn = null;
      if (add) {
        // Only honour a click that happened within the last 8s (covers the
        // network round-trip on slow connections).
        if (lastClickedAddBtn && (Date.now() - lastClickedAt) < 8000) {
          btn = lastClickedAddBtn;
        }
      }
      var p = nativeFetch.apply(this, arguments);
      if (add) {
        p.then(function (resp) {
          if (!resp) return;
          var ok = resp.ok || (resp.status >= 200 && resp.status < 300);
          if (!ok) return;
          resp.clone().json().then(function (data) {
            if (data && data.status && data.status !== 200) return;
            // TASK-2071 — consume the click the instant it fires so a SECOND
            // /cart/add landing inside the 8s window (e.g. auto gift line)
            // cannot replay the fly for the same button.
            if (btn && btn === lastClickedAddBtn) {
              lastClickedAddBtn = null;
              lastClickedRect = null;
            }
            if (btn) { flyToCart(btn); } else { dispatchFlyLanded(); }
          }).catch(function () {
            if (btn && btn === lastClickedAddBtn) {
              lastClickedAddBtn = null;
              lastClickedRect = null;
            }
            if (btn) { flyToCart(btn); } else { dispatchFlyLanded(); }
          });
        }).catch(function () { /* network error: no toast */ });
      }
      return p;
    };
  }
})();
